import { adminAuthContract } from './auth.contract.js';
import { adminMembersContract } from './members.contract.js';
import { adminTermsContract } from './terms.contract.js';
import { adminOAuthProvidersContract } from './oauth-providers.contract.js';
import { adminUsersContract } from './admin-users.contract.js';
import { adminUsersProfileContract } from './users.contract.js';
import { adminHealthContract } from './health.contract.js';
import { adminIngestContract } from './ingest.contract.js';
import { adminCommunicationsContract } from './communications.contract.js';
import { adminRealtimeContract } from './realtime.contract.js';
import { adminAnalysisContract } from './analysis.contract.js';
export { adminAuthContract } from './auth.contract.js';
export { adminMembersContract } from './members.contract.js';
export { adminTermsContract } from './terms.contract.js';
export { adminOAuthProvidersContract } from './oauth-providers.contract.js';
export { adminUsersContract, ADMIN_USER_ROLES, adminUserRoleSchema, } from './admin-users.contract.js';
export { adminUsersProfileContract } from './users.contract.js';
export { adminHealthContract } from './health.contract.js';
export { adminIngestContract } from './ingest.contract.js';
export { adminCommunicationsContract } from './communications.contract.js';
export { adminRealtimeContract } from './realtime.contract.js';
export { adminAnalysisContract, TOP_DONORS_CACHE_MAX_AGE_SECONDS, topDonorsPeriodSchema, topDonorRankItemSchema, topDonorsPayloadSchema, } from './analysis.contract.js';
export { ADMIN_WEBPUBSUB_HUB, adminPubSubGroup } from './webpubsub.js';
/** admin-api ts-rest 계약 묶음이다. 키는 Nest 모듈·admin-web API 클라이언트와 맞춘다. */
export const adminContract = {
    auth: adminAuthContract,
    members: adminMembersContract,
    terms: adminTermsContract,
    oauthProviders: adminOAuthProvidersContract,
    adminUsers: adminUsersContract,
    users: adminUsersProfileContract,
    health: adminHealthContract,
    ingest: adminIngestContract,
    communications: adminCommunicationsContract,
    realtime: adminRealtimeContract,
    analysis: adminAnalysisContract,
};
//# sourceMappingURL=index.js.map